<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" style="">
    <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none" class="" style="" />

    <defs>
      <filter
        id="colored_check_filter"
        x="0.02929689921438694"
        y="6.780270099639893"
        width="86.3333969116211"
        height="76.9751968383789"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="18" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.069375 0 0 0 0 0.230625 0 0 0 0 0.163835 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.12 0" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
      </filter>
    </defs>
    <g class="currentLayer" style="">
      <title>Layer 1</title>
      <rect
        x="-6.214892864227295"
        y="25.01008242368698"
        width="43.840599060058594"
        height="43.840599060058594"
        rx="21.920299530029297"
        transform="rotate(-45 -6.214891910552982,25.010082244873043) "
        fill="#D6F7E9"
        id="svg_1"
        class=""
      />
      <g filter="url(#colored_check_filter)" id="svg_2" class="">
        <path
          d="M44.14780747104883,10.790381738233567 L23.29360747104883,31.765581738233564 L13.814407471048831,22.231381738233566 "
          stroke="#198A5B"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
          id="svg_3"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: 'currentColor',
    },
    stroke: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>

<style></style>
